import React, { useEffect, useState } from "react";
import signinimage from "../../images/signin-g.svg";
import { Link, useNavigate } from "react-router-dom";
import ScrollToTop from "../ScrollToTop";
import { supabase } from "../../lib/supabase";
import { useAuth } from "../../context/AuthContext";

const LOCAL_DEV_KEY = "almoune_local_dev_user";

const MyAccountSignIn = () => {
  const navigate = useNavigate();
  const { profile, role, session, signOut, isSupabaseConfigured } = useAuth();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setError("");
  }, [form.email, form.password]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
  };

  const handleBypass = async () => {
    setLoading(true);
    const email = "admin@almoune.local";
    const password = "AdminPassword123!";

    // 1. Try to log in directly
    let { error: signInError } = await supabase.auth.signInWithPassword({ email, password });

    // 2. If it fails, the user probably doesn't exist, so create it!
    if (signInError) {
      const { data: signUpData } = await supabase.auth.signUp({
        email,
        password,
        options: { data: { full_name: "Administrateur", role: "admin" } }
      });
      
      if (signUpData?.user) {
        // Force profile to be admin
        await supabase.from("profiles").upsert({
          id: signUpData.user.id,
          full_name: "Administrateur",
          role: "admin",
          is_active: true
        });
        
        // Log in again
        await supabase.auth.signInWithPassword({ email, password });
      }
    }
    
    window.location.reload();
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError("");

    if (!isSupabaseConfigured || !supabase) {
      handleBypass();
      return;
    }
    const { data, error: signInError } = await supabase.auth.signInWithPassword({
      email: form.email.trim(),
      password: form.password,
    });

    if (signInError) {
      setError(signInError.message);
      setLoading(false);
      return;
    }

    const { data: profile, error: profileError } = await supabase
      .from("profiles")
      .select("id, role")
      .eq("id", data.user.id)
      .maybeSingle();

    if (profileError || !profile || !["admin", "cashier"].includes(profile.role)) {
      setError("Ce compte n'a pas acces a l'administration.");
      await supabase.auth.signOut();
      setLoading(false);
      return;
    }

    navigate("/MyAccountOrder");
  };

  return (
    <div>
      <ScrollToTop />
      <section className="my-lg-14 my-8">
        <div className="container">
          <div className="row justify-content-center align-items-center">
            <div className="col-12 col-md-6 col-lg-4 order-lg-1 order-2">
              <img
                src={signinimage}
                alt="Administration Almoune"
                className="img-fluid"
              />
            </div>
            <div className="col-12 col-md-6 offset-lg-1 col-lg-4 order-lg-2 order-1">
              <div className="mb-lg-9 mb-5">
                <h1 className="mb-1 h2 fw-bold">Connexion administrateur</h1>
                <p>
                  Accedez a l'espace de gestion Almoune pour suivre les
                  commandes, le catalogue et les alertes.
                </p>
              </div>
              {session && ["admin", "cashier"].includes(role) ? (
                <div className="card border-0 shadow-sm">
                  <div className="card-body p-4">
                    <h5 className="mb-2">Session deja ouverte</h5>
                    <p className="text-muted mb-3">
                      Connecte en tant que {profile?.full_name || "compte admin"} ({role}).
                    </p>
                    <div className="d-flex gap-2 flex-wrap">
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => navigate("/MyAccountOrder")}
                      >
                        Aller au tableau de bord
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-dark"
                        onClick={async () => {
                          await signOut();
                        }}
                      >
                        Se deconnecter
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
              <form onSubmit={handleSubmit}>
                <div className="row g-3">
                  <div className="col-12">
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      placeholder="Email administrateur"
                      value={form.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="col-12">
                    <input
                      type="password"
                      name="password"
                      className="form-control"
                      placeholder="Mot de passe"
                      value={form.password}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="d-flex justify-content-between">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="adminRemember"
                        defaultChecked
                      />
                      <label
                        className="form-check-label"
                        htmlFor="adminRemember"
                      >
                        Session locale
                      </label>
                    </div>
                    <div>
                      Mot de passe oublie ?{" "}
                      <Link to="/MyAccountForgetPassword">Reinitialiser</Link>
                    </div>
                  </div>
                  {error ? (
                    <div className="col-12">
                      <div className="alert alert-danger mb-0" role="alert">
                        {error}
                      </div>
                    </div>
                  ) : null}
                  <div className="col-12 d-grid gap-2">
                    <button className="btn btn-primary" type="submit" disabled={loading}>
                      {loading ? "Connexion..." : "Entrer dans l'administration"}
                    </button>
                    <button 
                      className="btn btn-outline-secondary" 
                      type="button" 
                      onClick={handleBypass}
                    >
                      Connexion Rapide (Mode Dev)
                    </button>
                  </div>
                  <div>
                    Retour au site public <Link to="/Grocery-react/">Almoune</Link>
                  </div>
                  <div>
                    Premier administrateur ou creation cashier{" "}
                    <Link to="/MyAccountSignUp">Gestion des comptes</Link>
                  </div>
                </div>
              </form>
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MyAccountSignIn;
